import apiClient from './apiClient';

export interface ResourceRollupRow {
  resourceId: string;
  name: string;
  resourceCode: string;
  resourceType: string;
  unitOfMeasure: string;
  unitCost: number | null;
  leadTimeDays: number;
  procurementEligible: boolean;
  quantityRequired: number;
  quantityAllocated: number;
  quantityConsumed: number;
  totalCost: number | null;
  taskCount: number;
  earliestNeedDate: string | null;
}

type ApiEnvelope<T> = { success?: boolean; data?: T };

const unwrap = <T>(response: any): T => {
  const body = response?.data ?? response;
  const envelope = body as ApiEnvelope<T>;
  return envelope && Object.prototype.hasOwnProperty.call(envelope, 'data')
    ? (envelope.data as T)
    : (body as T);
};

export interface ResourceCatalogItem {
  id: string;
  resourceCode: string;
  name: string;
  unitOfMeasure: string;
  resourceType: string;
  category?: string | null;
}

class ResourcesService {
  async getRollup(taskIds: string[]): Promise<ResourceRollupRow[]> {
    if (taskIds.length === 0) return [];
    const params = new URLSearchParams({ taskIds: taskIds.join(',') });
    const response = await apiClient.get<ApiEnvelope<ResourceRollupRow[]>>(
      `/resources/rollup?${params.toString()}`
    );
    return unwrap<ResourceRollupRow[]>(response) || [];
  }

  /**
   * Catalog list for pickers (e.g. Materials picker on Task Detail).
   * Optional `q` substring filter on name/code. Server caps at 500 rows.
   */
  async list(q?: string): Promise<ResourceCatalogItem[]> {
    const query = q && q.trim() ? `?q=${encodeURIComponent(q.trim())}` : '';
    const response = await apiClient.get<ApiEnvelope<ResourceCatalogItem[]>>(`/resources${query}`);
    return unwrap<ResourceCatalogItem[]>(response) || [];
  }
}

export default new ResourcesService();
